import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=fe643320&scoped=true"
import script from "./CommodityManage.vue?vue&type=script&lang=js"
export * from "./CommodityManage.vue?vue&type=script&lang=js"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&id=fe643320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe643320",
  null
  
)

export default component.exports